export class UserRoleRequest {
    groupId: number;
    groupName: string;
    roleId: number;
    roleName: string;
    permList: number[];
    deletedPerms: number[];
}